'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useState } from 'react';
import { CatSearchForm } from '@blocks-react/components/SearchForm';
import cx from 'classnames';
import styles from './HeaderSearchBar.module.scss';
import { Conditional } from '../../common';
import { CatIconSearch } from '@blocks-react/components/Icons/Search';
export const HeaderSearchBar = ({ placeholder, onSearch, onChange, children, hideResults, isNavMenuUpdateFlag = false, isMobile, mobileBreakPoint, size = 'md', initialSearchValue = '', onBlMobileOverlayOpen, onBlMobileOverlayClose, isFederatedSearchEnabled, hasNoResults, hasKeywordsOrCategories }) => {
    const [searchValue, setSearchValue] = useState(initialSearchValue ?? '');
    const [isActive, setIsActive] = useState(false);
    const isSearchActive = isMobile ? isActive : !hideResults;
    const isEmpty = isMobile ? false : hideResults;
    const setSearchInputValue = (value) => {
        setSearchValue(value);
        return value?.toLowerCase().replace(/:/g, '');
    };
    const onChangeHandler = (event) => {
        const searchInputValue = event.detail.value ?? '';
        const searchValue = setSearchInputValue(searchInputValue);
        onChange(searchValue, searchInputValue);
    };
    const onSearchHandler = (event) => {
        const searchInputValue = event.detail.value ?? '';
        const searchValue = setSearchInputValue(searchInputValue);
        onSearch(searchValue, searchInputValue);
    };
    const onMobileOverlayOpen = () => {
        if (onBlMobileOverlayOpen) {
            onBlMobileOverlayOpen();
        }
        setIsActive(true);
    };
    const onMobileOverlayClose = () => {
        if (onBlMobileOverlayClose) {
            onBlMobileOverlayClose();
        }
        setIsActive(false);
    };
    return (_jsx("div", { className: cx({ 'mb-2': isMobile }, { [styles['header-search-bar--width']]: !isMobile }, 'flex-grow-1'), children: _jsx(CatSearchForm, { status: undefined, size: size, className: cx(styles['header-search-bar'], {
                [styles['header-search-bar--increment-drop-down-width']]: !hasNoResults &&
                    isFederatedSearchEnabled &&
                    hasKeywordsOrCategories,
                [styles['header-search-bar--no-max-height']]: isFederatedSearchEnabled
            }), placeholder: placeholder, "data-testid": "cat-header-search-bar", onBlChange: onChangeHandler, onBlSearch: onSearchHandler, isEmpty: isEmpty, isActive: isSearchActive, mobileBreakPoint: mobileBreakPoint, onBlMobileOverlayOpen: onMobileOverlayOpen, onBlMobileOverlayClose: onMobileOverlayClose, position: "bottom-start", value: searchValue, hideSearchIcon: !isMobile, hideText: isNavMenuUpdateFlag, children: _jsxs(Fragment, { children: [_jsx(Conditional, { test: !!isMobile, children: _jsx(CatIconSearch, { slot: "before", "data-testid": "cat-header-search-icon", "aria-label": "Search" }) }), children] }, "search-input") }) }));
};
